<template>
  <common-wrap :preview-data="previewData" v-loading="loading">
    <div id="video-container" v-show="showPlayer">
      <video ref="videoPlayer" class="video-js"></video>
    </div>
  </common-wrap>
</template>

<script>
import "video.js/dist/video-js.min.css";
import Video from "video.js";
import commonWrap from "@/components/commonWrap";
import common from "@/mixins/common";

export default {
  name: "video-preview",
  mixins: [common],
  components: {
    commonWrap
  },
  data() {
    return {
      loading: false,
      player: null,
      showPlayer: false,
      option: {
        autoplay: true,
        controls: true,
        width: 720,
        height: 480,
        sources: []
      }
    }
  },
  async mounted() {
    const res = await this.getBlobData();
    if (res) {
      const blob = new Blob([res.data], {
        type: `video/${this.previewData.fileType};charset=utf-8`
      });
      console.log('res', res);
      const content = window.URL.createObjectURL(blob);
      console.log('content', content);
      this.$set(this.option.sources, '0', {
        src: content,
        type: `video/${this.previewData.fileType}` || 'video/mp4'
      })
      this.initVideo();
    }
  },
  methods: {
    // async getData() {
    //   this.loading = true;
    //   const res = await this.$http.get(this.previewData.fileUrl, {
    //     responseType: 'blob'
    //   });
    //   this.loading = false;
    //   if (res.data) {
    //     const blob = new Blob([res.data], {
    //       type: `video/${this.previewData.fileType};charset=utf-8`
    //     });
    //     console.log('res', res);
    //     const content = window.URL.createObjectURL(blob);
    //     console.log('content', content);
    //     this.$set(this.option.sources, '0', {
    //       src: content,
    //       type: `video/${this.previewData.fileType}` || 'video/mp4'
    //     })
    //     this.initVideo();
    //   } else {
    //     this.$message({
    //       type: 'error',
    //       message: res.data.message || '预览资源加载异常'
    //     });
    //   }
    // },

    initVideo() {
      console.log('video option', this.option);
      Video.Vhs.xhr.beforeRequest = (options) => {
        const header = {
          responseType: 'blob'
        };
        options.headers = Object.assign(options.headers, header);
        return options;
      }
      this.showPlayer = true;
      this.player = Video(this.$refs.videoPlayer, this.option, () => {
        this.player.log('onPlayerReady');
      });
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
      this.showPlayer = false;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "video.js/dist/video-js.css";

#video-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
